/***
 *
 *   BREADCRUMBS
 *   Navigation trail for nested pages. Ported from
 *   ui-reference/src/components/layouts/breadcrumbs.tsx: `/` separators,
 *   `text-sm`, and the current item in `font-medium text-text-secondary`.
 *
 *   The reference takes an explicit `items` array. Here the trail is normally
 *   derived from BreadcrumbsContext (route titles + pushed params), so `items`
 *   is the override rather than the input.
 *
 *   PROPS
 *   items: array of { name, url, isActive } (optional)
 *
 **********/

import { Fragment } from 'react';
import { NavLink } from 'react-router-dom';
import { useBreadcrumbsContext } from 'components/lib';
import Style from './breadcrumbs.tailwind.js';

export function Breadcrumbs(props) {
    // Optional-chained, not destructured: `items` is an override, so a caller
    // that passes it must work outside BreadcrumbsContextProvider — which is
    // what the api-key view does.
    const context = useBreadcrumbsContext();
    const trail = (props.items || context?.paramsList)?.filter((item) => item.name);

    if (!trail?.length) return null;

    return (
        <nav aria-label="Breadcrumb" className={Style.breadcrumbs}>
            {trail.map((item, index) => {
                const current = index === trail.length - 1 || item.isActive;

                return (
                    <Fragment key={`${item.name}-${index}`}>
                        {index > 0 && (
                            <span className={Style.separator} aria-hidden>
                                /
                            </span>
                        )}

                        {current ? (
                            <span className={Style.current} aria-current="page">
                                {item.name}
                            </span>
                        ) : (
                            <NavLink to={item.url} className={Style.link}>
                                {item.name}
                            </NavLink>
                        )}
                    </Fragment>
                );
            })}
        </nav>
    );
}
